export enum ItemCategoryCode {
  BIKE = 'BIKE',
  EBIKE = 'EBIKE',
  SPECIALBIKE = 'SPECIALBIKE', // Liegevelo
  BAGGAGE = 'BAGGAGE',
  CM = 'CM', // CompanyMail
  SKI = 'SKI',
  GOLF = 'GOLF'
}

export class ItemCategory {

  public static getIconName(code: string): string {
    switch (code) {
      case ItemCategoryCode.BIKE:
        return 'bicycle-small';
      case ItemCategoryCode.EBIKE:
        return 'bike-profile-power-plug-small';
      case ItemCategoryCode.SPECIALBIKE:
        return 'specialbike';
      case ItemCategoryCode.BAGGAGE:
        return 'suitcase-small';
      case ItemCategoryCode.CM:
        return 'envelope-small';
      case ItemCategoryCode.SKI:
        return 'skis-ski-poles-small';
      case ItemCategoryCode.GOLF:
        return 'golf';
      default:
        return 'suitcase-small';
    }
  }
}
